module.exports = __webpack_public_path__ + "img/prot-17000.6099e09b.png";